import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const DRxInfo: FC = () => {
  const params = useParams<{ symbol: string }>();

  useEffect(() => {
    const symbol = params.symbol as string || '';

    window.location.href =
      `https://www.settrade.com/th/redirect?symbol=${encodeURIComponent(symbol)}`;
  }, [params.symbol]);

  return <div></div>;
};

export default DRxInfo;
